import styled from "styled-components"
const ErrorSpan = styled.span`
  color: ${(props) => props.theme.colors.primary};
  display: block;
  font-size: 0.75rem;
  font-size: clamp(0.8rem, 0.76rem + 0.2vw, 1rem);
  font-weight: 700;
  grid-area: error;
`

export { ErrorSpan }
